import { fetchWhatsNew } from '../api/endpoints';
import type { WhatsNewItem } from '../model/types';

// Fetched when first opened and kept for the page load: the list only changes
// when the backend is deployed, and that reloads the page (new appVersion).
// A failed fetch is forgotten, so the next open asks again.
let whatsNew: Promise<WhatsNewItem[]> | undefined;

export function loadWhatsNew(): Promise<WhatsNewItem[]> {
    if (!whatsNew) {
        const request = fetchWhatsNew();
        whatsNew = request;
        request.catch(() => {
            if (whatsNew === request) {
                whatsNew = undefined;
            }
        });
    }
    return whatsNew;
}

export function resetWhatsNewForTests(): void {
    whatsNew = undefined;
}
